import { getApiRequest } from 'api';
import { StaffProfile } from 'types/staffProfile';
import { UserRoles } from 'types/user';

export const getProctors = (): Promise<StaffProfile[]> => {
    return getApiRequest(`/staff-profile/?user_role=${UserRoles.PROCTOR}`);
};
